// React/Redux
import React, { Component } from "react";
import { connect } from "react-redux";

// Material UI
import ButtonBase from "@material-ui/core/ButtonBase";

// PAC
import { salesStatuses } from "./salesStatuses";

class AuditArrow extends Component {
  state = {
    activities: []
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      const { activities } = this.props;

      this.setState({
        activities
      });
    }
  }

  onClick = e => {
    e.preventDefault();
    this.props.onClick("Audit", salesStatuses.AUDIT);
  };

  render() {
    return (
      <div className="arrow-container">
        <div className="arrow-btn arrow-audit">
          <ButtonBase onClick={this.onClick}>
            <span className="arrow-btn-label">
              {this.state.activities.length} <br />
              Audit
            </span>
          </ButtonBase>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    activities: state.salesActivity.audit
  }
}

export default connect(mapStateToProps)(AuditArrow);
